/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import PinVerification from "./PinVerification.container";

export default PinVerification;
